import{VERSION_STORAGE_KEY as t}from"../../../constants/VERSION_STORAGE_KEY/VERSION_STORAGE_KEY.js";var o=function(o){void 0===o&&(o=t);var r=localStorage.getItem(btoa(String(o)));return r?atob(r):void 0};export{o as getVersion};
//# sourceMappingURL=getVersion.js.map
